import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpMarker, OpRange, OpPolygon, OpLegendItem } from './op-map-area'

export class OpMapControl extends OpDashboardControl {
    //Properties
    public markers: OpMarker[]
    public ranges: OpRange[]
    public polygons: OpPolygon[]
    public legendItems: OpLegendItem[]
    public iconDict: Dictionary<any>
    public shortDetailsEnabled: boolean
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        super(opObj)
        if (opObj) {
            if (opObj.Markers)
                this.markers = opObj.Markers.map(data => new OpMarker(data))
            if (opObj.Ranges)
                this.ranges = opObj.Ranges.map(data => new OpRange(data))
            if (opObj.Polygons)
                this.polygons = opObj.Polygons.map(data => new OpPolygon(data))
            if (opObj.LegendItems)
                this.legendItems = opObj.LegendItems.map(data => new OpLegendItem(data))
            this.iconDict = null//TO DO konwersja z System.Collections.Generic.Dictionary
            this.shortDetailsEnabled = opObj.shortDetailsEnabled
        }
        if (!this.markers)
            this.markers = []
        if (!this.ranges)
            this.ranges = []
        if (!this.polygons)
            this.polygons = []
        if (!this.legendItems)
            this.legendItems = []
        if (!this.iconDict)
            this.iconDict = new Dictionary(null)
    }
}